import { render, staticRenderFns } from "./AnnouncementPushEditJG.vue?vue&type=template&id=0d975ce6"
import script from "./AnnouncementPushEditJG.vue?vue&type=script&lang=js"
export * from "./AnnouncementPushEditJG.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementPushEditJG.vue?vue&type=style&index=0&id=0d975ce6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports